import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated You no longer need to use a context provider with the message bus.
 */
const MessageBusProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default MessageBusProvider;